import { create } from 'zustand';
import axiosInstance from '../api/axiosInstance';
import toast from 'react-hot-toast';

const useCartStore = create((set, get) => ({
  cartItems: [],
  loading: false,

  fetchCart: async () => {
    try {
      set({ loading: true });
      const response = await axiosInstance.get('/cart');
      set({ cartItems: response.data.data, loading: false });
    } catch (error) {
      set({ loading: false });
    }
  },

  addToCart: async (productId, quantity, variationId = null) => {
    try {
      const url = variationId
        ? `/cart/add?productId=${productId}&quantity=${quantity}&variationId=${variationId}`
        : `/cart/add?productId=${productId}&quantity=${quantity}`;
      await axiosInstance.post(url);
      toast.success('Item added to cart');
      get().fetchCart();
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to add item');
    }
  },

  updateCartItem: async (cartItemId, quantity) => {
    try {
      await axiosInstance.put(`/cart/${cartItemId}?quantity=${quantity}`);
      get().fetchCart();
    } catch (error) {
      toast.error('Failed to update cart');
    }
  },

  removeFromCart: async (cartItemId) => {
    try {
      await axiosInstance.delete(`/cart/${cartItemId}`);
      toast.success('Item removed from cart');
      get().fetchCart();
    } catch (error) {
      toast.error('Failed to remove item');
    }
  },

  clearCart: async () => {
    try {
      await axiosInstance.delete('/cart/clear');
      set({ cartItems: [] });
    } catch (error) {
      toast.error('Failed to clear cart');
    }
  },

  getCartTotal: () => {
    return get().cartItems.reduce(
      (total, item) => total + item.unitPrice * item.quantity, 0
    );
  },

  getCartCount: () => {
    return get().cartItems.reduce((count, item) => count + item.quantity, 0);
  },
}));

export default useCartStore;